import { round } from "@repo/system";
import { type FlexMenu, type FlexProduct } from "~/api/menus/types";

/**
 * The product price the server will charge for one pre-order line: the product
 * and its extras, less its hybrid-billing discount, in whole minor units. A
 * deposit never goes in here, so a discount can never reduce it.
 */
export function discountedUnitPriceInclVat(
  product: FlexProduct,
  discounts: FlexMenu["discounts"],
  extraUnitPriceInclVat: number
): number {
  const hybridBillingDiscount = discounts.find(
    (discount) => discount.id === product.discount?.id
  );

  const unitPriceWithExtraInclVat =
    product.unitPriceInclVat + extraUnitPriceInclVat;

  if (!hybridBillingDiscount) {
    return round(unitPriceWithExtraInclVat, 0);
  }

  if (hybridBillingDiscount.amountType === "currency") {
    return round(unitPriceWithExtraInclVat - hybridBillingDiscount.amount, 0);
  }

  return round(
    unitPriceWithExtraInclVat -
      (unitPriceWithExtraInclVat * hybridBillingDiscount.amount) / 100,
    0
  );
}
